<template>
  <div class="max-w-7xl mx-auto p-8">
    <!-- TODO: 模試付与機能の追加 -->
    <!-- <div class="flex flex-row-reverse items-center">
      <button
        class="mr-2 px-8 py-2 rounded bg-green-500 text-white max-w-max shadow-sm hover:shadow-lg"
        @click.prevent="show = true">
        選択した学校に模試を付与
      </button>
      <button
        class="mr-2 px-8 py-2 rounded bg-green-500 text-white max-w-max shadow-sm hover:shadow-lg"
        @click.prevent="show = true">
        全学校に模試を付与
      </button>
    </div> -->
    <!-- TODO: リスト内検索機能の追加 -->
    <!-- <div class="col-span-3 mb-4">
      PerPage:
      <select
        :value="paginatePerPage"
        @change="onChangedPerPage"
        class="ml-2 pl-2 rounded border-gray-400"
      >
        <option v-for="(n, i) in paginatePerPages" :key="i">
          {{ n }}
        </option>
      </select>
    </div>
    <div class="grid grid-cols-12 mb-4">
      <input
        type="search"
        v-model="form.id"
        class="col-span-2 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
        placeholder="ID"
      />
      <input
        type="search"
        v-model="form.nameKeyword"
        class="col-span-3 ml-6 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
        placeholder="学校名"
      />
      <button
        class="col-span-1 relative ml-8 px-6 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
        @click.prevent="onSearchButtonClicked"
      >
        <svg
          class="absolute pointer-events-none w-6 h-6 top-1/4 left-1/4 text-white"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path
            d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
          />
        </svg>
      </button>
      <button
        class="col-span-2 bg-white hover:bg-gray-100 text-black ml-4 py-2 px-1 border border-gray-200 rounded shadow"
        @click.prevent="onResetButtonClicked"
      >
        リセット
      </button>
    </div> -->
    <div class="shadow-lg bg-white mr-1 rounded-b-lg rounded-t">
      <div v-if="schools.length">
        <data-table
          hover-disabled
          drag-disabled
          :sort="sort"
          :order="order"
          :headers="headers"
          :items="schools">
          <template #th-checkbox>
            <input
              v-model="selectedCurrentPageQuestions"
              type="checkbox"
              class="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded focus:outline-none" />
          </template>
          <template #check_box="{ item }">
            <input
              v-model="selectedQuestions"
              :value="item.id"
              type="checkbox"
              class="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded focus:outline-none"
              @click="onClickedCheckBox" />
          </template>
          <template #student_id="{ item }">
            <div class="text-left px-6">
              {{ item.id ?? "-" }}
            </div>
          </template>
          <template #name="{ item }">
            <div
              class="text-left px-6"
              style="width: 200px">
              {{ item.name ?? "-" }}
            </div>
          </template>
          <template #email="{ item }">
            <div class="text-left px-6">
              {{ item.email ?? "-" }}
            </div>
          </template>
        </data-table>
        <div
          v-if="schools.total > paginatePerPage"
          class="mb-5 pb-5">
          <div class="mt-4">
            <pagination
              :paginate="schools"
              @page-previous="onPaginationChanged"
              @page-next="onPaginationChanged"
              @page-click="onPaginationChanged" />
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="mx-auto w-11/12 bg-red-100 border border-red-400 text-red-500 px-4 py-3 rounded relative text-center"
          role="alert">
          <span
            class="block sm:inline font-bold">ユーザーが見つかりませんでした。</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import {
  reactive, ref, onMounted, computed,
} from 'vue'
import moment from 'moment'
import Swal from 'sweetalert2'
import AppClientSchoolLayout from '@/Layouts/AppClientSchoolLayout'
import DataTable from '@/Common/DataTable'
import Pagination from '@/Common/Pagination'
import DialogModal from '@/Common/DialogModal'

const props = defineProps({
  schools: {
    type: Object,
    default: () => ({}),
  },
  sort: {
    type: String,
    default: 'id',
  },
  order: {
    type: String,
    default: 'asc',
  },
})

const showModal = ref(false)
const paginatePerPage = ref('15')
const paginatePerPages = ['5', '10', '15', '30', '50', '100']

const headers = {
  check_box: '',
  id: 'ID',
  name: '学校名',
  email: 'メールアドレス',
}

const form = reactive(
  Inertia.form({
    id: props.id,
    nameKeyword: props.nameKeyword,
  }),
)

const onSearchButtonClicked = () => {
  Inertia.get(
    route('school', {
      sort: props.sort,
      order: props.order,
      studentId: form.studentId,
      serviceYears: form.serviceYears,
      departmentKeyword: form.departmentKeyword,
      nameKeyword: form.nameKeyword,
      limit: props.limit,
    }),
  )
}

const onResetButtonClicked = () => {
  form.studentId = ''
  form.serviceYears = ''
  form.departmentKeyword = ''
  form.nameKeyword = ''
  Inertia.get(
    route('school', {
      sort: props.sort,
      order: props.order,
      studentId: form.studentId,
      serviceYears: form.serviceYears,
      departmentKeyword: form.departmentKeyword,
      nameKeyword: form.nameKeyword,
      limit: props.limit,
    }),
  )
}

const onPaginationChanged = (page) => {
  Inertia.get(
    route('school', {
      page,
      limit: props.limit,
      sort: props.sort,
      order: props.order,
      studentId: props.studentId,
      serviceYears: props.serviceYears,
      departmentKeyword: props.departmentKeyword,
      nameKeyword: props.nameKeyword,
    }),
  )
}

const selectedQuestions = ref([])
const selectedCurrentPageQuestions = computed({
  get: () => false,
  set: (bool) => {
    if (bool) {
      selectedQuestions.value = props.schools.map((item) => item.id)
    } else {
      selectedQuestions.value = []
    }
  },
})
</script>
